import { render, staticRenderFns } from "./AbsentsIndex.vue?vue&type=template&id=662f9156"
import script from "./AbsentsIndex.vue?vue&type=script&lang=js"
export * from "./AbsentsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports